import React from 'react';
import { ApplicationView, useController } from '@aha-app/mvc';
import RecordPickerController from '../controllers/RecordPickerController';
import { AhaSearchField } from 'components/common/reactifyWebComponent';
import SearchResults from './SearchResults';
import EmptyState from './EmptyState';
import Selection from './Selection';
import RecordTypeFilter from './RecordTypeFilter';

const RecordPickerContent: React.FC = () => {
  const controller = useController(RecordPickerController);
  const { loading } = controller.state;

  const visibleResults = controller.getVisibleResults();
  const showResults = loading || visibleResults.length > 0;

  return (
    <>
      <div
        className='tw-overflow-y-auto tw-flex tw-flex-col tw-gap-4 tw-grow'
        style={{ width: 750 }}
      >
        <div className='tw-flex tw-items-center tw-gap-4'>
          <AhaSearchField
            autofocus
            class='tw-w-full'
            loading={loading}
            placeholder='Search Aha! records'
            style={{ minHeight: 30 }}
            throttled={false}
            onInput={event =>
              controller.actionPerformSearch(event.target.value)
            }
          />
          <RecordTypeFilter />
        </div>

        {showResults ? (
          <>
            {controller.showRecents() && <h5>Recently viewed records</h5>}
            <SearchResults results={visibleResults} />
          </>
        ) : (
          <EmptyState />
        )}
      </div>

      <div
        slot='right-content'
        className='tw-overflow-y-auto'
        style={{ scrollbarWidth: 'thin' }}
      >
        <Selection />
      </div>
    </>
  );
};

export default ApplicationView(RecordPickerContent);
